import { render } from "./sensor-type.vue?vue&type=template&id=6a37dcfd"
import script from "./sensor-type.vue?vue&type=script&lang=js"
export * from "./sensor-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__